import { createAction } from 'typesafe-actions';

import { Specialty } from 'shared/types/filters/specialtyTypes';

export const changeSpecialtyTypeTitleAction = createAction('filters/specialtyTypeTitleChanged')<Specialty>();
export const setSpecialtyTypeTitlesAction = createAction('filters/setSpecialtyTypeTitles')<Specialty[]>();
